// initial state
const state = () => ({
    requests: 0,
    messages: [],
    messagesRead: [],
    inboxPendingCount: 0
});

// getters
const getters = {
    getRequestsState(state) {
        return state.requests;
    },
    getMessagesState(state) {
        return state.messages;
    },
    getMessagesReadState(state) {
        return state.messagesRead;
    },
    getInboxPendingCount(state) {
        return state.inboxPendingCount;
    },
};

// actions
const actions = {};

// mutations
const mutations = {
    setRequestsStateChanged(state) {
        state.requests++;
    },
    setNewMessageReceived(state, payload) {
        state.messages = payload;
    },
    setNewMessageRead(state, payload) {
        state.messagesRead = payload;
    },
    setInboxPendingCount(state, payload) {
        state.inboxPendingCount = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
